/*
 * Animated Input Functions - Requires animated-input classes or the Animated Input component
 */

/**
 * Animates the input field on focus
 * @param {string} id - id of animated input
 */
export function animatedInputFocus(id) {
  const element = document.getElementById(id);
  if (element) { element.className = "filled"; }
}

/**
 * Animates the input field on blur
 * @param {string} id - id of animated input
 */
export function animatedInputBlur(id) {
  const element = document.getElementById(id);
  if (element && element.value.length === 0) { element.className = ""; }
}

/**
 * Toggles displaying or hiding the password
 * @param {string} id - id of animated input
 */
export function animatedInputPasswordToggle(id) {
  const element = document.getElementById(id);
  const password = document.getElementById(`${id}-show`);
  if (element && password) {
    if (element.type !== "password") {
      element.type = "password";
      password.classList.remove('shown');
    } else {
      element.type = "input";
      password.classList.add('shown');
    }
  }
}